import React from 'react';

const MyTab = ({ record, type }) => {
    return (
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    );
}

export default MyTab;